module.exports = __webpack_public_path__ + "img/msc_seminar_2023_banner_3.f66dab10.jpg";